import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import DrawerCopy from '../copy/getDrawerData';
import MobileCopy from '../copy/Mobile';
import UserLinkCopy from '../copy/getUserLinks';
import { usabillaLink, getWufooURL } from '../../../helpers/languageHelpers';
import { createURLHelper } from '../components/Drawer/getDrawerData';
import { getHelpLinkLangFromCode } from '../../../helpers/getHelpLink';

export const enterprise = () => ({
  title: t(DrawerCopy.ENTERPRISE),
  subTitle: t(DrawerCopy.ENTERPRISE_SUBTITLE),
  url: createURL(
    '/mp/enterprise/',
    createURLHelper('enterprise', '7MQAU', 'Enterprise', 'SME', 'SME')
  ),
});

export const audience = () => ({
  title: t(DrawerCopy.AUDIENCE),
  subTitle: t(DrawerCopy.AUDIENCE_SUBTITLE),
  url: createURL('/market-research/solutions/audience-panel/', {
    ut_source: 'header_products_launchpad_audience',
  }),
});

export const integrations = () => ({
  title: t(DrawerCopy.INTEGRATIONS_AND_PLUGINS),
  subTitle: t(DrawerCopy.INTEGRATIONS_AND_PLUGINS_SUBTITLE),
  url: createURL(
    '/apps/',
    createURLHelper('integrations', '7RQAU', 'Enterprise', 'Salesforce', 'SME')
  ),
});

export const cx = () => ({
  title: 'CX',
  subTitle: 'Understand & improve customer experience (NPS®)',
  url: createURL(
    'https://www.surveymonkey.com/cx/',
    createURLHelper('cx', '7bQAE', 'Solutions', 'CX', 'CX')
  ),
});

export const engage = () => ({
  title: 'Engage',
  subTitle: 'Understand & increase employee engagement',
  url: createURL(
    'https://www.surveymonkey.com/engage/',
    createURLHelper('engage', '7vQAE', 'Solutions', 'Engage', 'Engage')
  ),
});

export const techValidate = () => ({
  title: 'TechValidate',
  subTitle: 'Create marketing content from customer feedback',
  url: createURL(
    'https://www.surveymonkey.com/techvalidate/',
    createURLHelper('techvalidate', '880QAE', 'Solutions', 'TV', 'TV')
  ),
});

export const wufoo = lang => ({
  title: 'Wufoo',
  subTitle: t(DrawerCopy.WUFOO_SUBTITLE),
  url: createURL(getWufooURL(lang), {
    ut_source: 'header_products_launchpad_wufoo',
  }),
});

export const apply = () => ({
  title: 'Apply',
  subTitle: t(DrawerCopy.APPLY_SUBTITLE),
  url: createURL('https://apply.surveymonkey.com/', {
    ut_source: 'header_products_launchpad_apply',
    program: '7013A000000mY8AQAU',
  }),
});

export const usabilla = lang => ({
  title: 'Usabilla',
  subTitle: t(DrawerCopy.USABILLA_SUBTITLE),
  url: createURL(usabillaLink(lang), {
    utm_source: 'header_products_launchpad',
  }),
});

export const getFeedback = () => ({
  title: 'GetFeedback',
  subTitle: 'Customer feedback for Salesforce',
  url: createURL('https://www.getfeedback.com/', {
    utm_source: 'surveymonkey',
  }),
  openInNewWindow: true,
});

export const helpCenter = lang => ({
  title: t(DrawerCopy.HELP_CENTER),
  subTitle: t(DrawerCopy.HELP_CENTER_SUBTITLE),
  url: createURL('https://help.surveymonkey.com/', {
    l: getHelpLinkLangFromCode(lang),
    ut_source: 'header',
  }),
});

export const blog = () => ({
  title: t(DrawerCopy.SURVEYMONKEY_BLOG),
  subTitle: t(DrawerCopy.SURVEYMONKEY_BLOG_SUBTITLE),
  url: createURL('/curiosity/', { ut_source: 'header' }),
});

export const products = () => ({
  title: t(MobileCopy.PRODUCTS),
});

export const help = () => ({
  title: t(MobileCopy.HELP),
});

export const myAccount = () => ({
  url: createURL('/user/account/', { ut_source: 'header' }),
  title: t(UserLinkCopy.MY_ACCOUNT),
});

export const switchAccount = () => ({
  url: createURL('/user/account/select/', { ut_source: 'header' }),
  title: t(UserLinkCopy.SWITCH_ACCOUNTS),
});

export const team = () => ({
  url: createURL('/team', { ut_source: 'header' }),
  title: t(UserLinkCopy.MY_TEAM),
});

export const library = () => ({
  url: createURL('/team/library', { ut_source: 'header' }),
  title: t(UserLinkCopy.LIBRARY),
});

export const contacts = () => ({
  url: createURL('/addressbook/', { ut_source: 'header' }),
  title: t(UserLinkCopy.CONTACTS),
});
export const benchmark = () => ({
  url: createURL('/benchmarks/home/', {
    ut_source: 'header_username_menu',
    ut_source2: 'wide_menu',
  }),
  title: t(UserLinkCopy.BENCHMARKS),
});

export const signOut = () => ({
  url: createURL('/user/sign-out/', { ut_source: 'header' }),
  title: t(UserLinkCopy.SIGN_OUT),
});
